<template>
    <div class="relative sm:flex items-center p-4 sm:space-x-4">
        <div class="flex-1 flex sm:space-x-4">
            <div class="hidden sm:block flex-shrink-0">
                <div
                    class="flex items-center justify-center w-32 h-32 object-contain rounded border"
                    :style="`background-color: ${job.job_type.color};`"
                >
                    <span class="text-4xl text-white font-extrabold">{{
                        job.job_type.slug
                    }}</span>
                </div>
            </div>
            <div class="flex-1">
                <div class="flex space-x-2">
                    <div class="sm:hidden">
                        <div
                            class="flex items-center justify-center w-12 h-12 object-contain rounded border"
                            :style="`background-color: ${job.job_type.color};`"
                        >
                            <span class="text-lg text-white font-extrabold">{{
                                job.job_type.slug
                            }}</span>
                        </div>
                    </div>
                    <div>
                        <Link @click="updateJobTracker" class="hover:underline">
                            <h3 class="inline-block font-semibold text-lg">
                                {{ job.title }}
                            </h3>
                        </Link>
                        <!-- <p class="text-xs text-gray-500 font-medium">
              revised on {{ revisedOn || createdAt }}
            </p> -->
                    </div>
                </div>

                <p class="mt-2 text-gray-500 flex space-x-1">
                    <span>$</span>
                    <span
                        ><span class="text-2xl font-bold text-gray-900">{{
                            weeklyPayRange
                        }}</span>
                        / week</span
                    >
                </p>

                <ul class="mt-4 text-sm" v-if="keyPoints.length">
                    <li
                        v-for="(keyPoint, index) in keyPoints"
                        :key="`key_point_${index}`"
                        class="flex space-x-2"
                    >
                        <div class="mt-0.5 flex-shrink-0">
                            <svg
                                xmlns="http://www.w3.org/2000/svg"
                                class="sm:mt-0 h-4 w-4 text-gray-500"
                                viewBox="0 0 20 20"
                                fill="currentColor"
                            >
                                <path
                                    fill-rule="evenodd"
                                    d="M10 18a8 8 0 100-16 8 8 0 000 16zm3.707-9.293a1 1 0 00-1.414-1.414L9 10.586 7.707 9.293a1 1 0 00-1.414 1.414l2 2a1 1 0 001.414 0l4-4z"
                                    clip-rule="evenodd"
                                />
                            </svg>
                        </div>
                        <p class="text-gray-700">{{ keyPoint }}</p>
                    </li>
                </ul>

                <div class="mt-4 flex justify-between items-center space-x-4">
                    <div class="flex space-x-4">
                        <div class="flex space-x-2">
                            <span
                                class="text-xs font-medium px-2 py-1 bg-gray-100 border border-gray-200 rounded-md"
                                >{{ job.job_type.name }}</span
                            >
                            <span
                                class="text-xs font-medium uppercase px-2 py-1 bg-gray-100 border border-gray-200 rounded-md"
                                >CDL {{ job.cdl_class }}</span
                            >
                            <span
                                v-if="job.sap"
                                class="text-xs font-medium uppercase px-2 py-1 bg-gray-100 border border-gray-200 rounded-md"
                                >SAP</span
                            >
                        </div>
                        <div class="sm:flex sm:space-x-4">
                            <p class="flex items-center space-x-2">
                                <span class="text-gray-500">
                                    <svg
                                        xmlns="http://www.w3.org/2000/svg"
                                        class="h-4 w-4"
                                        viewBox="0 0 20 20"
                                        fill="currentColor"
                                    >
                                        <path
                                            fill-rule="evenodd"
                                            d="M4 4a2 2 0 012-2h8a2 2 0 012 2v12a1 1 0 110 2h-3a1 1 0 01-1-1v-2a1 1 0 00-1-1H9a1 1 0 00-1 1v2a1 1 0 01-1 1H4a1 1 0 110-2V4zm3 1h2v2H7V5zm2 4H7v2h2V9zm2-4h2v2h-2V5zm2 4h-2v2h2V9z"
                                            clip-rule="evenodd"
                                        />
                                    </svg>
                                </span>
                                <span
                                    class="text-sm text-gray-600 font-medium"
                                    >{{ job.company.name }}</span
                                >
                                <span v-if="isAgent" class="text-sm">
                                    {{ job.label ? ` - ${job.label}` : "" }}
                                </span>
                            </p>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <div
            v-if="isAgent && jobFacts.length"
            class="mt-4 sm:mt-0 border border-gray-300 shadow-sm p-2 rounded-md bg-gray-50/50"
        >
            <div class="flex items-center space-x-2">
                <svg
                    xmlns="http://www.w3.org/2000/svg"
                    fill="none"
                    viewBox="0 0 24 24"
                    stroke-width="1.5"
                    stroke="currentColor"
                    class="w-6 h-6"
                >
                    <path
                        stroke-linecap="round"
                        stroke-linejoin="round"
                        d="M20.25 14.15v4.25c0 1.094-.787 2.036-1.872 2.18-2.087.277-4.216.42-6.378.42s-4.291-.143-6.378-.42c-1.085-.144-1.872-1.086-1.872-2.18v-4.25m16.5 0a2.18 2.18 0 0 0 .75-1.661V8.706c0-1.081-.768-2.015-1.837-2.175a48.114 48.114 0 0 0-3.413-.387m4.5 8.006c-.194.165-.42.295-.673.38A23.978 23.978 0 0 1 12 15.75c-2.648 0-5.195-.429-7.577-1.22a2.016 2.016 0 0 1-.673-.38m0 0A2.18 2.18 0 0 1 3 12.489V8.706c0-1.081.768-2.015 1.837-2.175a48.111 48.111 0 0 1 3.413-.387m7.5 0V5.25A2.25 2.25 0 0 0 13.5 3h-3a2.25 2.25 0 0 0-2.25 2.25v.894m7.5 0a48.667 48.667 0 0 0-7.5 0M12 12.75h.008v.008H12v-.008Z"
                    />
                </svg>

                <h3 class="font-bold">Job Facts</h3>
            </div>
            <ul
                class="mt-4 text-sm max-h-[20vh] max-w-lg overflow-y-auto"
                v-if="jobFacts.length"
            >
                <li
                    v-for="(jobFact, index) in jobFacts"
                    :key="`key_point_${index}`"
                    class="flex space-x-2"
                >
                    <p class="font-medium">{{ index + 1 }}.</p>
                    <p class="text-gray-700 first-letter:uppercase">
                        {{ jobFact }}
                    </p>
                </li>
            </ul>
        </div>
        <div class="flex justify-end sm:justify-start mt-4 sm:mt-0">
            <div class="w-full sm:w-auto flex flex-shrink-0 sm:pr-4 space-x-2">
                <button
                    class="w-full block text-center px-4 py-3 sm:py-2 text-white text-sm font-medium rounded-md bg-blue-600 hover:bg-blue-700 shadow transition"
                    @click="updateJobTracker"
                    type="submit"
                >
                    More Info
                </button>
            </div>
        </div>
    </div>
</template>

<script>
import { DateTime } from "luxon";

import { useForm, Link } from "@inertiajs/inertia-vue3";

import { HeartIcon } from "@heroicons/vue/outline";
import { HeartIcon as HeartIconSolid } from "@heroicons/vue/solid";
import { Inertia } from "@inertiajs/inertia";

export default {
    props: {
        job: Object,
    },

    setup(props) {
        const saveForm = useForm({
            job: props.job.id,
        });
        const deleteForm = useForm({});

        const trackerForm = useForm({
            click: true,
        });

        const route = window.route;

        return {
            route,
            trackerForm,
            saveForm,
            deleteForm,
        };
    },

    computed: {
        jobStatusClass() {
            return {
                "bg-green-500 text-white": this.job.job_status === "open",
                "bg-red-500 text-white": this.job.job_status === "closed",
                "bg-purple-500 text-white": this.job.job_status === "ask",
                "bg-yellow-500 text-black": this.job.job_status === "hidden",
            };
        },
        createdAt() {
            return DateTime.fromISO(this.job.created_at).toLocaleString(
                DateTime.DATE_MED
            );
        },

        revisedOn() {
            if (!this.job.revised_on) return null;

            return DateTime.fromISO(this.job.revised_on).toLocaleString(
                DateTime.DATE_MED
            );
        },

        weeklyPayRange() {
            if (this.job.job_info?.average_weekly_pay_range) {
                return this.job.job_info?.average_weekly_pay_range;
            }
            return "-";
        },
        weeklyPay() {
            if (this.job.average_weekly_pay) {
                return this.job.average_weekly_pay
                    .toString()
                    .replace(/\B(?=(\d{3})+(?!\d))/g, ",");
            }
            return "-";
        },
        keyPoints() {
            return Array.from(Array(5).keys())
                .map((key) => this.job[`key_point_${key + 1}`])
                .filter(Boolean);
        },
        jobFacts() {
            return Array.from(Array(10).keys())
                .map((key) => this.job.job_info[`job_fact_${key + 1}`])
                .filter(Boolean);
        },
        isSaved() {
            const auth = this.$page.props.auth;

            if (!auth) return false;

            return auth.saved_jobs.includes(this.job.id);
        },

        isAgent() {
            const auth = this.$page.props.auth;
            return (
                auth &&
                (auth.role.includes("agent") ||
                    auth.role.includes(
                        "Restricted Agent to companies US Xpress, Heartland and DB Schenker"
                    ))
            );
        },


        logo() {
            const logo = this.job.company.logo;

            return logo ? `/storage/${logo}` : `/images/logo.png`;
        },
    },

    methods: {
        // route: window.route,

        /**
         * Here i redirect the user to job show page after i update the click tracker.
         * i couldn't be able to find a better way to handle two api route calls at time.
         */
        updateJobTracker() {
            this.trackerForm.post(
                route("update.job.tracker", { job: this.job }),
                {
                    onSuccess: () => {
                        Inertia.get(
                            route("jobs.show", {
                                job: this.job,
                                slug: this.job.slug,
                            })
                        );
                    },
                }
            );
        },
    },

    components: {
        Link,
        HeartIcon,
        HeartIconSolid,
    },
};
</script>
